import './PreviewLinkButton.scss';

import { bem } from 'mission-control-common-components';
import React, { useCallback } from 'react';

import Button from '../Button';
import { PREVIEW_IN_DXC_TITLE } from './constants';
import { useFetchExternalPreviewLink } from './hooks';

type PreviewLinkButtonProps = {
  experienceId?: string | null;
};

const [block] = bem('preview-button');

const PreviewLinkButton = ({ experienceId }: PreviewLinkButtonProps): React.JSX.Element => {
  const { onFetchExperiencePreviewLink, isLoading } = useFetchExternalPreviewLink();

  const onHandlePreviewButtonClick = useCallback(() => onFetchExperiencePreviewLink(experienceId), [
    experienceId,
    onFetchExperiencePreviewLink,
  ]);

  return (
    <Button
      variant="outlined"
      data-testid="experience-preview-link"
      onClick={onHandlePreviewButtonClick}
      disabled={!experienceId || isLoading}
      tabIndex={0}
      loading={isLoading}
      aria-label="experience-preview-link"
      className={block()}
    >
      {PREVIEW_IN_DXC_TITLE}
    </Button>
  );
};

export default PreviewLinkButton;
